<template>
  <div>
    <banner :title="'CISP/NISP培训'">
    </banner>
    <div class="section">
      <div class="section-content">
        <div v-html="content" class="html-cont" style="padding: 20px 32px;background-color: #fbfbfb;line-height: 32px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '../components/Banner.vue'
import { getArticleByCateId } from '../api';
export default {
  components: { Banner },
  data() {
    return {
      content: ''
    }
  },
  created() {
    getArticleByCateId({cateId: '11'}).then(res => {
      if (res.data) {
        this.content = res.data[0].htmlContent
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.section {
  &-content {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    padding: 20px 0;
    min-height: 200px;
    text-align: justify;
    .html-cont {
      ::v-deep {
        p {
          line-height: 32px;
        }
      }
    }
  }
}
</style>